import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Cookies } from 'react-cookie';

const ProtectedRoute = ({ allowedRoles, children }) => {
  const { role } = useSelector((state) => state.auth);
  const location = useLocation();

  const cookies = new Cookies();
  const cookieRole = cookies.get('role');
  const effectiveRole = role || cookieRole;

  if (!effectiveRole) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (!allowedRoles.includes(effectiveRole)) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
};

export default ProtectedRoute;
